import pillar1 from "@images/investor-relations/pillars/pillar-1.webp";
import pillar2 from "@images/investor-relations/pillars/pillar-2.webp";
import pillar3 from "@images/investor-relations/pillars/pillar-3.webp";
import pillar4 from "@images/investor-relations/pillars/pillar-4.webp";

/**
 * Investment Case — Section 06 of the approved IR content sheet.
 * Copy lives under `investmentCase.pillarN` in `app/localization/investor.json`.
 */
export type PillarIcon = "sectors" | "globe" | "governance" | "vision";

export type Pillar = {
  key: "pillar1" | "pillar2" | "pillar3" | "pillar4";
  icon: PillarIcon;
  /** Background photo used when the pillar is the active card. */
  image: string;
  /** `object-position` for the active card's photo. */
  imagePosition: string;
  /**
   * Whether the approved copy splits into a summary plus a closing statement.
   * Pillar III is a single sentence, so it has no `detail` key and its card
   * shows no Read More toggle.
   */
  hasDetail: boolean;
};

export const pillars: Pillar[] = [
  {
    key: "pillar1",
    icon: "sectors",
    image: pillar1,
    imagePosition: "center 62%",
    hasDetail: true,
  },
  {
    key: "pillar2",
    icon: "globe",
    image: pillar2,
    imagePosition: "center 45%",
    hasDetail: true,
  },
  {
    key: "pillar3",
    icon: "governance",
    image: pillar3,
    imagePosition: "center 55%",
    hasDetail: false,
  },
  {
    key: "pillar4",
    icon: "vision",
    image: pillar4,
    imagePosition: "center 40%",
    hasDetail: true,
  },
];
